@if (currentBannerImg) {
<href [link]="currentBanner.redirectUrl"
      [hrefClass]="'block pos-relative overflow-hidden'">
    <shell></shell>
    <img [ratio]="client.isM || client.isS ? 1/3 : 1/8"
         [dfImage]="currentBannerImg"
         (click)="trackClick()"
         class="w-12 pos-relative"
         style="object-fit: cover;">
</href>
}
